import { render, staticRenderFns } from "./PFSettlementFormQuickView.vue?vue&type=template&id=10fac12d&scoped=true"
import script from "./PFSettlementFormQuickView.vue?vue&type=script&lang=js"
export * from "./PFSettlementFormQuickView.vue?vue&type=script&lang=js"
import style0 from "./PFSettlementFormQuickView.vue?vue&type=style&index=0&id=10fac12d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fac12d",
  null
  
)

export default component.exports